import * as TYPES from './type';
export default {
  //授课  教学轨迹
  [TYPES.SK_PORTRAYAL_TEACHING_TRACK](state, { result }) {
    state.SKteachingTrack = result.result
  },
  //授课  到课率
  [TYPES.SK_PORTRAYAL_COURSE_RATIO](state, { result }) {
    state.SKcourseRatio = result.result
  },
  //授课  作业率
  [TYPES.SK_PORTRAYAL_HOMEWORK_RATIO](state, { result }) {
    state.SKhomeworkRatio = result.result
  },
  //授课  任务率
  [TYPES.SK_PORTRAYAL_TASK_RATIO](state, { result }) {
    state.SKtaskRatio = result.result
  },
  //授课  测试率
  [TYPES.SK_PORTRAYAL_TEST_RATIO](state, { result }) {
    state.SKtestRatio = result.result
  },
  //授课  小组排名
  [TYPES.SK_PORTRAYAL_GROUP_LIST](state, { result }) {
    state.SKgroupList = result.result
  },
  //授课  学生进步排名
  [TYPES.SK_PORTRAYAL_STU_IMPROVE_LIST](state, { result }) {
    state.SKstuImproveList = result.result
  },
  //授课  学生活跃排名
  [TYPES.SK_PORTRAYAL_STU_LIVELY_LIST](state, { result }) {
    state.SKstuLivelyList = result.result
  },
  //授课  学生素质排名
  [TYPES.SK_PORTRAYAL_STU_QUALITY_LIST](state, { result }) {
    state.SKstuQualityList = result.result
  },
  //授课  学生成绩排名
  [TYPES.SK_PORTRAYAL_STU_ACHIEVEMENT_LIST](state, { result }) {
    state.SKstuAchievementList = result.result
  },
  //授课  活动参与率
  [TYPES.SK_PORTRAYAL_ACTIVE_RATIO](state, { result }) {
    state.SKactiveRatio = result.result
  },
}



// WEBPACK FOOTER //
// ./src/store/give-course/portrayal/mutations.js